module.exports = __webpack_public_path__ + "static/media/wrinkles_fullface.c1945eb6.svg";